'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _dropdowns = require('../inputs/enhancers/processOptions/dropdowns');

var dropdowns = _interopRequireWildcard(_dropdowns);

var _autofill = require('../inputs/enhancers/autofillOnFocus/autofill');

var autofill = _interopRequireWildcard(_autofill);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reducer = (0, _redux.combineReducers)({
  dropdowns: dropdowns.reducer,
  autofill: autofill.reducer
});

var store = (0, _redux.createStore)(reducer);

var element = _react2.default.createElement;
var provideRedux = function provideRedux(Component) {
  return function (props) {
    return element(_reactRedux.Provider, { store: store }, element(Component, props));
  };
};

exports.default = provideRedux;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/enhancers/provideRedux.js
// module id = 1086
// module chunks = 0